import useSWR from "swr/immutable";
import { useContext } from "react";
import { useRouter } from "next/router";

import { NavigationContext } from "~contexts/NavigationContext";

/**
 * Fetches breadcrumbs from API, only use when breadcrumbs cannot be fetched server side
 * eg: when using getStaticProps, see 404.js
 *
 * @returns {Array} Array of breadcrumbs
 */
const useBreadcrumbs = () => {
  const { breadcrumbs } = useContext(NavigationContext);
  const { locale, asPath } = useRouter();
  const { data } = useSWR(
    breadcrumbs
      ? null
      : `/api/breadcrumbs/${locale}?slug=${asPath.split("?")[0]}`,
    (url) => fetch(url).then((r) => r.json()),
  );

  return breadcrumbs ?? data?.breadcrumbs ?? [];
};

export default useBreadcrumbs;
